import React from 'react';
import {
  UserCheck,
  Receipt, DollarSign, TrendingUp, FileText, ChevronRight,
} from 'lucide-react';

const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

const DashboardKPIs = ({ stats, pedidosFiltrados, clientes, onNavigate }) => {
  const mesAtual = new Date().getMonth();
  const anoAtual = new Date().getFullYear();
  const clientesPositivados = new Set(
    pedidosFiltrados
      .filter(p => {
        const d = new Date(p.criado_em);
        return d.getMonth() === mesAtual && d.getFullYear() === anoAtual && p.status !== 'CANCELADO';
      })
      .map(p => p.cliente_id || p.cliente_nome)
  );
  const positivados = clientesPositivados.size;
  const totalClientes = clientes.length;
  const pctPositivacao = totalClientes > 0 ? Math.round(positivados / totalClientes * 100) : 0;
  const corPositivacao = pctPositivacao < 30 ? '#DC2626' : pctPositivacao < 60 ? '#D97706' : '#166534';
  const fundoPositivacao = pctPositivacao < 30 ? '#FEE2E2' : pctPositivacao < 60 ? '#FEF3C7' : '#DCFCE7';

  return (
    <>
      {/* ── KPIs PRINCIPAIS ── */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5">
        {[
          { label: 'Faturado no Mês',   value: brl(stats.faturado_mes_valor),           icon: Receipt,    cor: '#166534', fundo: '#DCFCE7' },
          { label: 'Comissão Realizada', value: brl(stats.comissao_realizada),           icon: DollarSign, cor: '#0A3D73', fundo: '#DBEAFE' },
          { label: 'A Receber',          value: brl(stats.comissoes_a_receber),          icon: TrendingUp, cor: '#92400E', fundo: '#FEF3C7' },
          { label: 'Pedidos em Aberto',  value: `${pedidosFiltrados.filter(p => ['PENDENTE','IMPLANTADO'].includes(p.status)).length}`, icon: FileText, cor: '#1E40AF', fundo: '#EFF6FF' },
        ].map((k, i) => (
          <div key={i} className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 overflow-hidden">
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs font-bold uppercase tracking-wide text-slate-400">{k.label}</p>
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: k.fundo }}>
                <k.icon size={15} style={{ color: k.cor }} />
              </div>
            </div>
            <p className="font-black" style={{ color: k.cor, fontSize: 'clamp(14px, 3.5vw, 24px)' }}>{k.value}</p>
          </div>
        ))}
      </div>

      {/* ── POSITIVAÇÃO DO MÊS ── */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 mb-5">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: fundoPositivacao }}>
              <UserCheck size={15} style={{ color: corPositivacao }} />
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-wide text-slate-400">Positivação do Mês</p>
              <p className="text-sm font-black text-slate-800">{positivados} de {totalClientes} clientes</p>
            </div>
          </div>
          <span className="text-2xl font-black" style={{ color: corPositivacao }}>{pctPositivacao}%</span>
        </div>
        <div className="w-full bg-slate-100 h-2 rounded-full overflow-hidden mb-2">
          <div className="h-full transition-all duration-1000 rounded-full"
            style={{ width: `${Math.min(pctPositivacao, 100)}%`, background: corPositivacao }} />
        </div>
        <div className="flex justify-between items-center">
          <p className="text-xs text-slate-400">{positivados} positivados · {totalClientes - positivados} pendentes</p>
          <button onClick={() => onNavigate('/clientes?filtro=nao_positivados')}
            className="text-xs font-black text-[#0A3D73] hover:underline flex items-center gap-1">
            Ver não positivados <ChevronRight size={11} />
          </button>
        </div>
      </div>
    </>
  );
};

export default DashboardKPIs;
